import { bconf } from "../../app/index";

export const doExcludeCategories = (arrExcludeCategories: string) => {
    const filteredCategories = bconf().CATEGORIES.filter((element) => {
      return !arrExcludeCategories.includes(element.key);
    });
    return filteredCategories;
  };